import Vue from "vue";
import { mapState } from "vuex";

import actionBarComponent from "@/components/child/actionBar/actionBar.vue";
import comboComponent from "@/components/child/form/combo.vue";
import { Component } from "@/decorators";
import UsuarioModel from "@/models/usuarioModel";
import EstoqueMinimoService from "@/services/estoqueMinimoService";
import grupoProdutoService from "@/services/produto/grupoProdutoService";
import { AppState, SessionActions } from "@/store/store";

@Component({
    components: {
        actionBarComponent,
        comboComponent,
    },
    computed: {
        ...mapState({
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
        }),
    },
})
export default class EstoqueMinimoComponent extends Vue {
    private service = new EstoqueMinimoService();
    coberturaEmDias = 30;
    mesesConsiderar = 6;
    grupoProdutoId?: number = null;
    grupoProdutoOptions: Array<Object> = [];
    usuarioLogado: UsuarioModel;

    private async onAtualizar() {
        try {
            const isValid = await this.$validator.validateAll();

            if (isValid) {
                const sucesso = await this.service
                    .calcularEstoque(this.mesesConsiderar, this.coberturaEmDias, this.grupoProdutoId)
                    .withLoading()
                    .resolveWithoutJSON();

                if (sucesso) {
                    this.$showSuccess(this.$t("__.ts.sucesso"), this.$t("__.ts.sucessoEstMin"));
                }
            }
        } catch {}
    }

    private async mounted() {
        await this.$store.dispatch(SessionActions.LOAD_USUARIO_LOGADO);

        const response = await Promise.all([
            grupoProdutoService.comboCached(this.usuarioLogado.franquiaId),
        ]).withLoading();

        this.grupoProdutoOptions = response[0];
    }
}
